import Head from 'next/head';
import PropTypes from 'prop-types';
import { ProvideAnalytics } from 'hooks/useAnalytics';
import '../styles/global.css';
import '../webflow.scss';
import 'intersection-observer';

const App = ({ Component, pageProps }) => (
  <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link
        rel="icon"
        href="/blog/favicon.svg"
        type="image/svg+xml"
        sizes="any"
      />
    </Head>
    <ProvideAnalytics>
      <Component {...pageProps} />
    </ProvideAnalytics>
  </>
);

App.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.shape({}).isRequired,
};

export default App;
